import { httpService } from "../App";

export interface RegisterClicksRequest {
  name: string;
  clicks: number;
  id: number;
}

//const TAG = "[ClickService]";

export class ClickService {
  async sendClicks(
    payload: Partial<RegisterClicksRequest | RegisterClicksRequest[]>
  ): Promise<void> {
    try {
      //console.log(`${TAG} sendClicks() - Sending payload:`, payload);
      await httpService
        .getClient()
        .post(`/api/clicks`, payload);

      //console.log(`${TAG} sendClicks() - Response received:`, response.data);
    } catch (error) {
      //console.error(`${TAG} sendClicks() - Error occurred:`, error);
    }
  }
}
